import { ReactElement } from "react";

import { BodySmall, Link, OpenInNewIcon, Box } from "@parspec/pixel";
export const LearnMore: React.FC<{ url: string, linkText: string }> = ({ url, linkText }): ReactElement => {
    return <Link target="_blank" href={url} underline="none" fontSize={'small'}>
        <Box display={'flex'} columnGap={1}>
            <BodySmall color={'primary.main'}>{linkText}</BodySmall>
            <OpenInNewIcon fontSize={'small'} />
        </Box>
    </Link>

}